import { render, staticRenderFns } from "./IconsVideo.vue?vue&type=template&id=5c8aa66e&"
import script from "./IconsVideo.vue?vue&type=script&lang=js&"
export * from "./IconsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8aa66e')) {
      api.createRecord('5c8aa66e', component.options)
    } else {
      api.reload('5c8aa66e', component.options)
    }
    module.hot.accept("./IconsVideo.vue?vue&type=template&id=5c8aa66e&", function () {
      api.rerender('5c8aa66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconsVideo.vue"
export default component.exports